import queryString from 'qs';

const siteAddressMap = {
  1177: '1177.se',
  RHB: 'rikshandboken-bhv.se',
  VHB: 'vardhandboken.se',
};

export const getExternalSiteAdress = (siteIndex) =>
  siteAddressMap[siteIndex] || 'vardpersonal.1177.se';

export const getRegionalizedUrl = (href) => {
  if (typeof href !== 'string') return;

  const qs = queryString.parse(location, { ignoreQueryPrefix: true });

  const splitPaths = qs.pathname?.split('/').filter(Boolean);
  const region = splitPaths?.length > 1 ? splitPaths[0] : null;

  if (!region) return href;

  const url = new URL(href);

  url.pathname = `/${region}${url.pathname}`;
  return url.href;
};
